import { render } from "./BankAccountsPage.vue?vue&type=template&id=2e6ba6ea"
import script from "./BankAccountsPage.vue?vue&type=script&lang=js"
export * from "./BankAccountsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__